export enum InvoiceStatus {
  All = 'all',
  Credited = 'credited',
  Deleted = 'deleted',
  Draft = 'draft',
  Open = 'open',
  Overdue = 'overdue',
  Paid = 'paid',
  PartiallyCredited = 'partially_credited',
  Reminded = 'reminded',
  Sent = 'sent',
  Unpaid = 'unpaid',
  Unsent = 'unsent',
}
